import React from "react";
import { usePortfolio } from "../../contexts/PortfolioContext";
import LogoBadge from "../public/LogoBadge";
import SectionHeading from "../public/SectionHeading";

const Experience = () => {
  const { portfolioData } = usePortfolio();
  const experienceData = portfolioData.experiences || [];

  if (experienceData.length === 0) return null;

  return (
    <section className="public-section public-section--tint" id="experience">
      <div className="container">
        <SectionHeading
          eyebrow="Experience"
          title="Where I've worked"
          description="Roles where I shipped production software, collaborated with teams, and learned how products actually get built."
          aside={
            <span className="section-count">
              {experienceData.length}{" "}
              {experienceData.length === 1 ? "role" : "roles"}
            </span>
          }
        />

        <div className="experience-list">
          {experienceData.map((exp, index) => {
            const bullets = Array.isArray(exp.description)
              ? exp.description.slice(0, 3)
              : [exp.description].filter(Boolean);
            const isCurrent = /present|current/i.test(exp.period || "");

            return (
              <article
                className="experience-card"
                key={exp.id || `${exp.company}-${index}`}
              >
                <div className="experience-aside">
                  <LogoBadge
                    src={exp.logo}
                    alt={exp.company}
                    fallback={(exp.company || "?").charAt(0)}
                  />
                  <span className="experience-period">{exp.period}</span>
                  {isCurrent && <span className="status-pill">Current</span>}
                </div>

                <div className="experience-body">
                  <h3 className="experience-role">{exp.position}</h3>
                  <p className="experience-company">
                    {exp.company}
                    {(exp.location || exp.type) && (
                      <span>
                        {" "}
                        · {[exp.location, exp.type].filter(Boolean).join(" · ")}
                      </span>
                    )}
                  </p>

                  {bullets.length > 0 && (
                    <ul className="experience-bullets">
                      {bullets.map((line, bulletIndex) => (
                        <li key={`${exp.id || index}-bullet-${bulletIndex}`}>
                          {line}
                        </li>
                      ))}
                    </ul>
                  )}

                  {exp.technologies?.length > 0 && (
                    <div className="chip-row experience-tech">
                      {exp.technologies.slice(0, 6).map((tech) => (
                        <span className="public-chip" key={tech}>
                          {tech}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Experience;
